import Config from '#/config'
import i18n from '#/locales'
// import app from "#/app";
import store from '#/stores'

export function ifNotAuthenticated() {
  if (!store.getters.isAuthenticated || !store.getters.hasAcceptedAgreements) {
    return true
  }
  const redirect = {
    name: 'home',
    params: { locale: i18n.global.locale.value },
  }
  return redirect
}

export function ifAuthenticated(to) {
  if (store.getters.isAuthenticated) {
    return true
  }
  else {
    return {
      name: 'auth.login',
      params: { locale: i18n.global.locale.value },
      query: { redirect: to.fullPath },
    }
  }
}

export function customizeHome(to) {
  if (store.getters.isAuthenticated) {
    switch (to.name) {
      case 'home.perso':
        return store.getters.canRecommend
          || store.getters.canRecommendCategories
          ? true
          : { name: 'home.user', params: { locale: i18n.global.locale.value } }
      case 'home.user':
        return store.getters.canRecommend
          || store.getters.canRecommendCategories
          ? { name: 'home.perso', params: { locale: i18n.global.locale.value } }
          : store.getters.roleIsGuest
            ? {
                name: 'home.guest',
                params: { locale: i18n.global.locale.value },
              }
            : true
      case 'home.guest':
        return store.getters.roleIsGuest
          ? true
          : { name: 'home.user', params: { locale: i18n.global.locale.value } }
    }
  }
  else {
    return {
      name: 'auth.login',
      params: { locale: i18n.global.locale.value },
      query: { redirect: to.fullPath },
    }
  }
}

export function ifUserKnown() {
  if (store.getters.isAuthenticated) {
    const redirect = {
      ...redirectByRole(store.state.auth.user),
      params: { locale: i18n.global.locale.value },
    }
    return redirect
  }
  else {
    return true
  }
}

export function toCorrectLogin() {
  const acceptedHostNames = [
    'localhost',
    'qa.curio.ca',
    'uat.curio.ca',
    'beta.curio.ca',
    'curio.dev.camr.io',
    'curio-dev.non-prod.camr.io',
    'curio-qa.non-prod.camr.io',
    Config.decodedHost,
  ]

  if (
    store.getters.getBaseUrl
    && !acceptedHostNames.includes(window.location.hostname)
  ) {
    window.location = `https://${Config.decodedHost}/${i18n.global.locale.value}/login`
  }
  return true
}

export function redirectByRole(auth) {
  const redirect = Config.auth.redirects.afterLoginSuccess[auth.role]
    ? Config.auth.redirects.afterLoginSuccess[auth.role]
    : Config.auth.redirects.afterLoginSuccess.default

  return redirect
}

export function ifUserIsAdmin() {
  if (store.getters.isAuthenticated && store.getters.roleIsAdmin) {
    return true
  }
  return {
    name: '403',
    params: { locale: i18n.global.locale.value },
  }
}

export function ifUserCanViewReports() {
  if (
    store.getters.isAuthenticated
    && (store.getters.roleIsAdmin || store.getters.roleIsLibraryUser)
  ) {
    return true
  }
  return {
    name: '403',
    params: { locale: i18n.global.locale.value },
  }
}
